import { QueryResource } from 'datx-jsonapi-react';

import { ProfileStatistics } from '@/resources/ProfileStatistics';

export const queryProfileStatistics = (id: string): QueryResource<ProfileStatistics> => {
  return id ? [ProfileStatistics, id] : null;
};
